import './instrument.js'
import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import './index.css'

const FallbackComponent = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang') || 'de';
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      backgroundColor: '#f9fafb',
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        padding: '32px',
        maxWidth: '400px',
        width: '100%',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>&#9888;</div>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#1f2937', marginBottom: '16px' }}>
          {lang === 'de' ? 'Ein Fehler ist aufgetreten' : 'Something went wrong'}
        </h2>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          {lang === 'de'
            ? 'Bitte laden Sie die Seite neu oder versuchen Sie es später erneut.'
            : 'Please reload the page or try again later.'}
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            width: '100%',
            padding: '12px 24px',
            backgroundColor: '#f43f5e',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
          }}
        >
          {lang === 'de' ? 'Seite neu laden' : 'Reload page'}
        </button>
      </div>
    </div>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={FallbackComponent}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
